function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.23735 10.8001C8.60546 11.2922 9.07509 11.6994 9.6144 11.994C10.1537 12.2887 10.7501 12.4639 11.3631 12.5078C11.976 12.5517 12.5913 12.4633 13.1671 12.2485C13.7429 12.0337 14.2657 11.6976 14.7002 11.2629L17.2716 8.69152C18.0523 7.88322 18.4843 6.80064 18.4745 5.67694C18.4648 4.55324 18.014 3.47833 17.2194 2.68372C16.4248 1.88912 15.3499 1.43839 14.2262 1.42863C13.1025 1.41886 12.0199 1.85084 11.2116 2.63152L9.73735 4.09723M11.6659 9.0858C11.2978 8.59369 10.8282 8.1865 10.2889 7.89185C9.74957 7.59721 9.1532 7.42199 8.54022 7.37809C7.92724 7.33419 7.31199 7.42263 6.7362 7.63742C6.16041 7.85221 5.63754 8.18832 5.20307 8.62295L2.63164 11.1944C1.85096 12.0027 1.41899 13.0853 1.42875 14.209C1.43852 15.3327 1.88924 16.4076 2.68385 17.2022C3.47845 17.9968 4.55336 18.4475 5.67706 18.4573C6.80076 18.467 7.88334 18.0351 8.69164 17.2544L10.1574 15.7887",
  stroke: "url(#paint0_linear_6089:1357)",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_6089:1357",
  x1: 9.95164,
  y1: 1.42847,
  x2: 9.95164,
  y2: 18.4574,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#161626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})));

function SvgChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.31c2e21a.svg";
export { ForwardRef as ReactComponent };